<template>
    <div class="l-stacked-grid l-stacked-grid--right">
        <div class="l-stacked-grid__item">
            <div @click="click" class="c-sortable-list__button">
                {{$t(i18n)}}
                <div class="o-button o-button--round icon-plus"></div>
            </div>

        </div>
        <div class="l-stacked-grid__item"></div>
    </div>
</template>

<script>
    import {Utils} from "@bvm/core";
    import {goToSpecialPage} from "@bvm/core/src/api/specialpage/specialpage.api";

    const i18nBuilder = new Utils.I18n.I18nBuilder('employee_form_register')
        .add('employee')
    export const messageKeys = i18nBuilder.getKeys();

    export default {
        name: "AddEmployeeElement",
        data() {
            return {
                i18n: i18nBuilder.getKeys()
            }
        },
        methods: {
            click() {
                goToSpecialPage('ADMIN_REGISTER');
            }
        }
    }
</script>
